import { GET_RECENT_ACTIVITY, GET_RECENT_ACTIVITY_SUCCESS, GET_RECENT_ACTIVITY_ERROR, GET_RECENT_ACTIVITY_EMPTY } from '../../actions';

const initialState = {
  data: null,
  message: null,
  loading: false,
  success: false,
  error: false,
};

const GetRecentActivity = (state = initialState, action) => {
  switch (action.type) {
    case GET_RECENT_ACTIVITY:
      state = {
        ...state,
        // data: null,
        loading: true,
        success: false,
        error: false,
        message: null,
      };
      break;

    case GET_RECENT_ACTIVITY_SUCCESS:
      state = {
        ...state,
        data: action.payload,
        loading: false,
        success: true,
        error: false,
        message: null,
      };
      break;

    case GET_RECENT_ACTIVITY_ERROR:
      state = {
        ...state,
        data: null,
        loading: false,
        success: false,
        error: true,
        message: action.payload,
      };
      break;

    case GET_RECENT_ACTIVITY_EMPTY:
      state = {
        ...initialState,
      };
      break;

    default:
      state = { ...state };
      break;
  }
  return state;
};

export default GetRecentActivity;
